import { locales } from '@repo/markets/markets'
import { LocaleIdentifier } from '@repo/markets/types'
import { usePathname, useRouter } from 'next/navigation'

const useLocalePrefetch = (currentLocale: LocaleIdentifier) => {
  const pathname = usePathname()
  const router = useRouter()

  const prefetch = () => {
    for (const l of locales.filter((l) => l !== currentLocale)) {
      router.prefetch(`${pathname.replace(`/${currentLocale}`, `/${l}`)}`)
    }
  }

  return { prefetch }
}

export default useLocalePrefetch
